
const initialState = 0

export const UPDATE_FRONT_STYLE_LVZ = 'UPDATE_FRONT_STYLE_LVZ'

export function frontStyleLvzReducer (state = initialState, action) {
    switch (action.type){
        case UPDATE_FRONT_STYLE_LVZ:
            return action.payload
        default: return state
    }
}